var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ButtonChipElement, TextElement } from './elements';
import { ChipIcon } from './ChipIcon';
import { noop } from '../../util';
export var ButtonChip = React.forwardRef(function (_a, fRef) {
    var label = _a.label, _b = _a.onClick, onClick = _b === void 0 ? noop : _b, _c = _a.size, size = _c === void 0 ? 'small' : _c, _d = _a.variant, variant = _d === void 0 ? 'normal' : _d, iconLeftSrc = _a.iconLeftSrc, iconRightSrc = _a.iconRightSrc, edgeItemsMargin = _a.edgeItemsMargin, rest = __rest(_a, ["label", "onClick", "size", "variant", "iconLeftSrc", "iconRightSrc", "edgeItemsMargin"]);
    return (React.createElement(ButtonChipElement, __assign({ ref: fRef, onClick: function () { return onClick(); }, role: "button", tabIndex: 0, "$size": size, "$variant": variant, "$edgeItemsMargin": edgeItemsMargin }, rest),
        iconLeftSrc && React.createElement(ChipIcon, { src: iconLeftSrc, size: size, side: "left" }),
        React.createElement(TextElement, null, label),
        iconRightSrc && React.createElement(ChipIcon, { src: iconRightSrc, size: size, side: "right" })));
});
